<script>
import Edit from './Edit.vue'
export default {
  extends: Edit,
  computed: {
    title() {
      return 'View Sale Account'
    },
    action() {
      return 'view'
    }
  }
}
</script>
